/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Type_EditInputs */

const vi_tea_type_edit = /** @type {(inputs: Tea_Type_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa loại chè`)
};

/**

* @param {Tea_Type_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_type_edit = /** @type {((inputs?: Tea_Type_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Type_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_type_edit(inputs)
});